(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
	key: "AIzaSyA8GglcZ-ptPGzhu8QhpEbr5ue8EcYsxh4", // API Key PROD
	v: "weekly",
	libraries: "places,geometry",
	//language: "it"
});

let map;
let mapCenter = {};
let viewport;
let queryParams = {
	address: null,
	lat: null,
	lng: null,
	viewport: null,
	country: null
}

const viewportExtension = 5; // voewport suggested by Google is expanded by 5km on every side

if ((location.search != null) && (location.search != "")) {
	updateQueryParams();
}

let zoomLevel = 10;
let prevZoomLevel = 0;
let markers = [];
let selectedMarkers = [];
let pin;
let oms;
let markerClusters;
let firstLoad = true;
let newSearch = false;
let draggingMap = false;
let isFiltering = false;

function updateQueryParams() {
	let queryParamsString = location.search.replace('?', '').split('&');

	queryParamsString.forEach( (s) => {
		let chunks = s.split('=');

		queryParams[chunks[0]] = decodeURI(chunks[1]);
	});

	mapCenter = {
		lat: parseFloat(queryParams.lat),
		lng: parseFloat(queryParams.lng)
	};
	viewport = JSON.parse(queryParams.viewport);
}

async function initSearchbox() {
	const {Geocoder} = await google.maps.importLibrary("geocoding");
	// Parametri per la ricerca con autocomplete
	const searchInput = document.getElementById("place-input");

	if (searchInput) {
		// https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter
		(function pacSelectFirst(input){
			//Store original event listener
			const _addEventListener       = input.addEventListener
			const addEventListenerWrapper = (type, listener) => {
				if (type === 'keydown') {
					/* Store existing listener function */
					const _listener = listener;

					listener = (event) => {
						/* Simulate a 'down arrow' keypress if no address has been selected */
						const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;

						if (event.key === 'Enter' && !suggestionSelected) {
							const e = new KeyboardEvent('keydown', {
								key: 'ArrowDown',
								code: 'ArrowDown',
								keyCode: 40,
							});

							_listener.apply(input, [e]);
						}

						_listener.apply(input, [event]);
					}
				}

				_addEventListener.apply(input, [type, listener]);
			}

			input.addEventListener = addEventListenerWrapper;
		})(searchInput);
		// FINE GESTIONE TASTO ENTER

		const searchOptions = {
			componentRestrictions: null,
			fields: ["formatted_address", "address_components", "geometry", "name"],
			strictBounds: false,
			//types: ["geocode"],
			types: ["locality", "country", "administrative_area_level_1", "administrative_area_level_2", "administrative_area_level_3"]
		};
		const autocomplete = new google.maps.places.Autocomplete(searchInput, searchOptions);

		// Aggiormamento stato pulsanti in base ai parametri in querystring
		updateOfflineSearchParams(
			queryParams.country,
			queryParams.address,
			queryParams.lat,
			queryParams.lng,
			queryParams.viewport,
			false
		);

		if (queryParams.address != null) {
			searchInput.setAttribute('value', queryParams.address);
		}

		initMap();

		autocomplete.addListener("place_changed", () => {
			const place = autocomplete.getPlace();

			if (!place.geometry || !place.geometry.location) {
				// User entered the name of a Place that was not suggested and
				// pressed the Enter key, or the Place Details request failed.
				window.alert("No results found for: '" + place.name + "'");
				return;
			}

			console.log(place);

			let selectedCountry = null;
			if (place.address_components != null) {
				place.address_components.forEach(item => {
					if (item.types.find(elem => elem == "country"))
						selectedCountry = item.short_name;
				});
			}

			updatePlace(place);
			updateOfflineSearchParams(
				selectedCountry,
				place.formatted_address,
				mapCenter.lat,
				mapCenter.lng,
				viewport,
				true
			);
		});
	}
}

async function initMap() {
	const { Map }    = await google.maps.importLibrary("maps");
	const {Geocoder} = await google.maps.importLibrary("geocoding");
	const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

	if (document.getElementById("map") != null) {

		// let mapStyles = [
		// 	{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},
		// 	{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},
		// 	{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"},{"color":"#484848"}]},
		// 	{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},
		// 	{"featureType":"landscape","elementType":"all","stylers":[{"color":"#eeedeb"}]},
		// 	{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#f2f2f2"}]},
		// 	{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#f4f4f4"}]},
		// 	{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"}]},
		// 	{"featureType":"landscape.man_made","elementType":"labels.text.fill","stylers":[{"color":"#ff0000"}]},
		// 	{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},
		// 	{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#ff0000"}]},
		// 	{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},
		// 	{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},
		// 	{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},
		// 	{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},
		// 	{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},
		// 	{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
		// 	{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},
		// 	{"featureType":"water","elementType":"all","stylers":[{"color":"#87b8cc"},{"visibility":"on"}]},
		// 	{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#87b8cc"}]},
		// 	{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#000000"}]},
		// 	{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}];

		map = new google.maps.Map(document.getElementById('map'), {
			center: mapCenter,
			minZoom: 3.5,
			maxZoon: 18,
			zoom: 6,
			//gestureHandling: 'greedy',
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: true,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			mapId: "d9ecfb24de2614e2"
			//styles: mapStyles
		});

		if (viewport != null) {
			map.fitBounds(viewport);
			map.setCenter(mapCenter);
		}
		else {
			map.setCenter(mapCenter);
			map.setZoom(zoomLevel);
		}

		prevZoomLevel = map.zoom;
		infowindow    = new google.maps.InfoWindow({ minWidth: 265, maxWidth: 265 });
		pin           = {
			path: 'M -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0',
			anchor: new google.maps.Point(0, 0),
			fillColor: '#444',
			fillOpacity: 1,
			scale: 0.75,
			strokeColor: '#444',
			strokeWeight: 1
		};

		// HANDLER EVENTI

        // Il pannello dei filtri e i market vengono mostrati solo dopo che la mappa è stata completamente caricata.
		google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
			//document.querySelector('#filters-wrapper.loading').classList.remove('loading');

			refreshMarkers(stores);
			refreshFilters();
		});

		// Handler per l'applicazione dei filtri
		document.querySelectorAll('.filter-group a').forEach( (elem) => {
			elem.addEventListener('click', (evt) => {
				let filterItem = evt.target.closest('a');

				if (!('prop' in filterItem.dataset))
					return;

				let filterType = filterItem.dataset.prop;

				if (!('val' in filterItem.dataset))
					return;

				let filterValue   = filterItem.dataset.val;
				let fileredStores = [];

				for (var i = 0; i < stores.length; i++) {
					if (stores[i].categories.indexOf(filterValue) >= 0)
						fileredStores.push(stores[i]);
				}

				//isFiltering = true; // serve per disattivare temporaneamente gli handler su zoom_changed e dragend
				refreshMarkers(fileredStores);
			});
		});

		// Inizializzazione libreria "spiderfier" per gestire i marker sovrapposti
		oms = new OverlappingMarkerSpiderfier(map, {
            markersWontMove: true,
            basicFormatEvents: true,
            keepSpiderfied: true,
            ignoreMapClick: false,
            nearbyDistance: 5
        });

		
		google.maps.event.addListener(map, "zoom_changed", debounce(function() {

			//console.log("ZOOM CHANGED");
			// console.log("Map zoom:" + map.getZoom());
			// console.log("Prev zoom:" + prevZoomLevel);

			if (!firstLoad && !newSearch && !draggingMap && !isFiltering && (map.getZoom() > prevZoomLevel) ) {
				// Aggiornamento viewpoirt
				viewport = map.getBounds().toJSON();
				console.log(viewport);
				searchOffline(false).then(() => {
					// Riattiva i flag una volta completata la ricerca
					newSearch = false;
					isFiltering = false;
				});
			}
			prevZoomLevel = map.zoom;

			// Reimposta il flag dopo il primo caricamento della mappa
			firstLoad = false;

		}, 300));
		
		google.maps.event.addListener(map, "dragend", function() {

			// console.log("MAP DRAGGED");
			// console.log("Map zoom:" + map.getZoom());
			// console.log("Prev zoom:" + prevZoomLevel);

			if (!firstLoad && !newSearch && !draggingMap && !isFiltering) {

				if (document.getElementById("place-input") != null) {
					document.getElementById("place-input").value = '';
					
					let newLatString = (map.getCenter().lat() > 0) ? "N " + map.getCenter().lat().toFixed(4) + "°" : "S " + Math.abs(map.getCenter().lat().toFixed(4)) + "°";
					let newLngString = (map.getCenter().lng() > 0) ? "E " + map.getCenter().lng().toFixed(4) + "°" : "W " + Math.abs(map.getCenter().lng().toFixed(4)) + "°";

					document.getElementById('place-input').value = "(" + queryParams.country + ") " + newLatString + ", " + newLngString;
				}

				draggingMap = true;

				// Aggiornamento viewport
				viewport = map.getBounds().toJSON();
				searchOffline(false).then(() => {
					// Riattiva i flag una volta completata la ricerca
					newSearch = false;
					draggingMap = false;
					isFiltering = false;
					draggingMap = false;
				});

				
			}
		});
		

		google.maps.event.addListenerOnce(map, 'idle', function() {

		});
	}
}

function clearMarkers() {
	for (var k in markers) {
		markers[k].setMap(null);
	}

	if (markerClusters) {
		markerClusters.clearMarkers();
	}

	// Svuots l'array dei marker
	markers.splice(0, markers.length);
}

// Aggiorna i contatori dei filtri sulla base dei dati presenti nella pagina
function refreshFilters() {
	let filtersOptions = [...document.querySelectorAll('#filter-category li')];

	for (let k = 0; k < filtersOptions.length; k++) {
		let cat   = filtersOptions[k].querySelector('[data-prop="category"]').dataset.val;
		let count = Array.from(document.querySelectorAll('.archive-item[data-category*="' + cat + '"]')).length;
		
		filtersOptions[k].querySelector('span.badge').innerText = count;
	}
}

// Aggiorna l'elenco dei pin sulla mappa
function refreshMarkers(points) {
	console.log("Refreshing markers...");
	console.log(points?.length + " found");

	clearMarkers();

	if (points != null) {
		// Posizionamento pin
		for (let i = 0; i < points.length; i++ ) {
			let item = points[i];
			let marker = new google.maps.Marker({
				position: {
					lat: item.lat,
					lng: item.lng
				},
				icon: pin,
				//map: map,
				customData: item
			});

			// I marker vengono aggiunti alla "spiderified map" per gestire più entità con le stesse coordinate geografiche
			oms.addMarker(marker);

			//google.maps.event.addListener(marker, "click", function() {
			google.maps.event.addListener(marker, "spider_click", function() {
				showMarkerInfo(this);
			});

			markers.push(marker);
		}

		// Inizializzazione clusterer
		let customRender = {
			render: ({ count, position }) => {
				// create svg literal with fill color
				const color = "#000";
				const svg   = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
				<circle cx="120" cy="120" opacity=".6" r="70" />
				<circle cx="120" cy="120" opacity=".3" r="90" />
				<circle cx="120" cy="120" opacity=".2" r="110" />
				<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
				</svg>`;
				const title = `${count} stores`;

				// adjust zIndex to be above other markers
				zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;

				const clusterOptions = {
					position,
					zIndex,
					title,
					icon: {
						url: `data:image/svg+xml;base64,${btoa(svg)}`,
						anchor: new google.maps.Point(25, 25),
					},
				};

				return new google.maps.Marker(clusterOptions);
			}
		};

        markerClusters = new markerClusterer.MarkerClusterer({
			map: map,
			markers: markers,
			renderer: customRender,
			algorithmOptions: {
				maxZoom: 14
			},
			onClusterClick: customClusterZoom,
		});
	}

	if (!draggingMap) {
		map.fitBounds(viewport);
	}

	// Reimposto il flag per abilitare le chiamate ajax allo zoom e al pan della mappa
	newSearch = false;
}

function customClusterZoom(event, cluster, map) {
	var clusterSize = getDistance(
		cluster.bounds.getNorthEast().lat(),
		cluster.bounds.getNorthEast().lng(),
		cluster.bounds.getSouthWest().lat(),
		cluster.bounds.getSouthWest().lng()
	);
	
	if (clusterSize < 0.5) {
		map.setCenter(cluster._position);
		map.setZoom(18);
	}
	else {
		map.fitBounds(cluster.bounds);
	}
}

function showMarkerInfo(marker) {
	if ( selectedMarkers != null && selectedMarkers.length > 0) {
		scaleDownIcon(selectedMarkers);
		// Svuota l'array dei marker selezionati
		selectedMarkers.splice(0, selectedMarkers.length);
  	}

	let windowContent = renderMarkerInfo(marker.customData);
	var center        = marker.getPosition();

	selectedMarkers.push(marker);
	scaleUpIcon(selectedMarkers);
	infowindow.setContent(windowContent);
	infowindow.setZIndex(1000);

	/*
	if (map.getZoom() < 12) {
		map.setZoom(12);
	}
	*/

	map.panTo(center);
	map.panBy(0, -180);
	infowindow.open(map, marker);
}

function getDistance(lat_1,lng_1,lat_2,lng_2) {
    var R    = 6371; // unit in kilometers
    var dLat = (lat_2-lat_1) * Math.PI / 180;
    var dLng = (lng_2-lng_1) * Math.PI / 180; 
    var a     = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat_1 * Math.PI / 180 ) * Math.cos(lat_2 * Math.PI / 180 ) * 
        Math.sin(dLng/2) * Math.sin(dLng/2); 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c;

    //return Math.round(d);
	return d;
}

// Rendering delle informazioni all'interno dell'infoWindow
function renderMarkerInfo(data) {
	let strContent = "";

	strContent = "<div class='info-window'>" +
		"<button class='custom-close' onclick='closePopup()'>" +
			"<svg class='icon' enable-background='new 0 0 18 18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>" +
				"<g fill='none' stroke='#000' stroke-width='2'>" +
					"<path d='m.9.9 15.8 15.8'></path><path d='m16.9 1-15.9 15.9'></path>" +
				"</g>" +
			"</svg>" +
		"</button>" +
		"<h3>" + data.title + "</h3>";

	if ((data.address != null) && (data.address != "")) {
		strContent += "<p><span class='address'>" + data.address + "</span></p>";
	}

	strContent += "<p>";

	if ((data.postalCode != null) && (data.postalCode != "")) {
		strContent += "<span class='postalcode'>" + data.postalCode + "</span>&nbsp;";
	}

	if ((data.city != null) && (data.city != "")) {
		strContent += "<span class='city'>" + data.city + "</span>&nbsp;";
	}

	if ((data.region != null) && (data.region != "")) {
		strContent += "<span class='region'>(" + data.region + ")</span>";
	}

	strContent += "</p>"

	if ((data.phone != null) && (data.phone != "")) {
		strContent += "<p><span class='phone'>" + data.phone + "</span></p>";
	}

	if ((data.fax != null) && (data.fax != "")) {
		strContent += "<p><span class='fax'>" + data.fax + "</span></p>";
	}

	if ((data.email != null) && (data.email != "")) {
		strContent += "<p><span class='email'><a href='mailto:" + data.email + "' target='_blank'>" + data.email + "</a></span></p>";
	}

	if ((data.website != null) && (data.website != "")) {
		strContent += "<p><span class='website'><a href='" + data.website + "' target='_blank'>" + data.website + "</a></span></p>";
	}

	// strContent += "<div class='mt-2 mb-1'><a class='button' href='" + getDirectionsUrl(data) + "' target='_blank'>Get directions</a></div>";
	strContent += "<div class='mt-2 mb-1'><a class='button' href='" + data.directionsUrl + "' target='_blank'>Get directions</a></div>";
	strContent += "</div>";

	return strContent;
}

// Custom handler per chiudere l'infoWindow
function closePopup() {
	scaleDownIcon(selectedMarkers);
	// Svuota l'array dei marker selezionati
	selectedMarkers.splice(0, selectedMarkers.length);
	infowindow.close();
}

// Funzione per ingrandire l'icona del marker.
function scaleUpIcon(markers) {
	var icon;

	if (markers != null && markers.length > 0) {
		for (var i = 0; i < markers.length; i++) {
			icon       = markers[i].getIcon();
			icon.scale = 1.5;

			markers[i].setIcon(icon);
		}
	}
}

// Funzione per ridimensionare l'icona del marker.
function scaleDownIcon(markers) {
	var icon;

	if (markers != null && markers.length > 0) {
	  for (var i = 0; i < markers.length; i++) {
		icon       = markers[i].getIcon();
		icon.scale = 0.75;

		markers[i].setIcon(icon);
	  }
	}
}

function updateOnlineSearchParams(term_id, queryArg, updateUrl = false) {
	let btnGotoSearch = document.getElementById('goto-online-search');
	
	if (term_id != null) {
		if (btnGotoSearch) {
			btnGotoSearch.removeAttribute("disabled");

			btnGotoSearch.href = btnGotoSearch.dataset.href + "?" + queryArg + "=" + term_id;
		}

		let btnSearch = document.getElementById('online-search');

		if (btnSearch) {
			btnSearch.removeAttribute("disabled");

			if (updateUrl) {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + queryArg + "=" + term_id;
				
				updateURL(newurl);
			}
		}
	}
	else {
		if (btnGotoSearch) {
			btnGotoSearch.setAttribute("disabled", true);
		}

		if (btnSearch) {
			btnSearch.setAttribute("disabled", true);

			if (updateUrl) {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				
				updateURL(newurl);
			}
		}
	}
}

function updateOfflineSearchParams(country, address, lat, lng, viewport, updateUrl = false) {
	let btnGotoSearch = document.getElementById('goto-offline-search');
	let btnSearch     = document.getElementById('offline-search');
	let btnMap        = document.getElementById('show-map');

	if ((address != null) && (lat != null) && (lng != null)) {
		if (btnGotoSearch) {
			btnGotoSearch.removeAttribute("disabled");

			btnGotoSearch.href = btnGotoSearch.dataset.href + "?country=" + country + "&address=" + encodeURI(address) + "&lat=" + lat + "&lng=" + lng;

			if (viewport != null) {
				btnGotoSearch.href += "&viewport=" + JSON.stringify(viewport);
			}
		}

		if (btnSearch) {
			btnSearch.removeAttribute("disabled");

			if (updateUrl) {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?country=" + country + "&address=" + encodeURI(address) + "&lat=" + lat + "&lng=" + lng;
				
				if (viewport != null) {
					newurl += "&viewport=" + JSON.stringify(viewport);
				}

				updateURL(newurl);
			}
		}

		if (btnMap) {
			btnMap.removeAttribute("disabled");
		}
	}
	else {
		if (btnGotoSearch) {
			btnGotoSearch.setAttribute("disabled", true);
		}

		if (btnSearch) {
			btnSearch.setAttribute("disabled", true);

			if (updateUrl) {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				
				updateURL(newurl);
			}
		}

		if (btnMap) {
			btnMap.setAttribute("disabled", true);
		}
	}
}

function updateURL(pageUrl) {
	if (typeof (history.pushState) != "undefined") {
        const state = { page_url: pageUrl };

        history.pushState(state, "", pageUrl);

		updateQueryParams()
    }
}

function updatePlace(place) {
	if (place.geometry) {
		if (place.geometry.viewport) {
			let viewportCenter = place.geometry.viewport.getCenter();

			viewport      = place.geometry.viewport;
			mapCenter.lat = viewportCenter.lat();
			mapCenter.lng = viewportCenter.lng();

			//drawViewport(viewport, "#FF0000");
			
			// Viewport expansion to widen search results
			let ne = viewport.getNorthEast();
			let sw = viewport.getSouthWest();

			let deltaLat = viewportExtension / 111;
			let deltaLngNorth = viewportExtension / (111.32 * Math.cos( ne.lat() * Math.PI / 180 ));
			let deltaLngSouth = viewportExtension / (111.32 * Math.cos( sw.lat() * Math.PI / 180 ));

			let a = new google.maps.LatLng(ne.lat() + deltaLat, ne.lng() + deltaLngNorth);
			let b = new google.maps.LatLng(sw.lat() - deltaLat, sw.lng() - deltaLngSouth);

			let extViewport = new google.maps.LatLngBounds(b, a);
			viewport = extViewport;

			//drawViewport(extViewport, "#0000FF");
		}
		else {
			mapCenter.lat = place.geometry.location.lat();
			mapCenter.lng = place.geometry.location.lng();
			viewport      = null;
			zoomLevel     = 12;
		}
	}
}

// Debug function to check viewport extension
function drawViewport(viewportToDraw, hexColor = "#FF0000") {
	// Viewport expansion to widen search results
	let originalViewport = new google.maps.Rectangle({
		strokeColor: hexColor,
		strokeOpacity: 0.8,
		strokeWeight: 2,
		fillColor: hexColor,
		fillOpacity: 0.25,
		map,
		bounds: viewportToDraw
	});
}

function geolocateMe() {
	if (!navigator.geolocation) {
		window.alert("Geolocation is not supported by your browser");
	} else {
		document.querySelector('#geolocate svg').classList.add('spinning');

		navigator.geolocation.getCurrentPosition(
			function (position){
				const myPos = {
					lat: position.coords.latitude,
    				lng: position.coords.longitude
				};

				let geocoder = new google.maps.Geocoder();

				geocoder.geocode({
					location: myPos
				}, (function(results, status) {
					if ("OK" === status) {
						let countryResult = results.filter((function(e) {
							return  "country" === e.types[0]
						}));;

						// Viene cercata per prima la località
						var r = results.filter((function(e) {
							return "locality" === e.types[0]
						}));
						// Come primo fall-back, viene cercata la provincia (non sempre sono valorizzati all'estero)
						if (r.length == 0) {
							r = results.filter((function(e) {
								return  "administrative_area_level_1" === e.types[0]
							}));
						}
						// Come soluzione estrema, viene ristretto il campo alla sola country
						if (r.length == 0) {
							r = countryResult;
						}

						if (r.length > 0) {
							document.getElementById('place-input').value = r[0].formatted_address;
							document.querySelector('#geolocate svg').classList.remove('spinning');

							updatePlace(r[0]);
							updateOfflineSearchParams(
								countryResult[0].address_components[0].short_name,
								r[0].formatted_address,
								r[0].geometry.location.lat(),
								r[0].geometry.location.lng(),
								r[0].geometry.viewport,
								true
							);

						} else {
							window.alert("No position found.");
						}
					} else {
						e.loaderLocateMe = !1;
						console.error("Geocoder failed due to: " + status);
					}
				}));
			},
			function (){
				window.alert("Unable to retrieve your location");
			});
	}
}

function searchOffline(clearFilters = false) {
	// Imposto questo parametro per evitare una seconda chiamata ajax quando viene riposizionata la mappa (scatta l'evento zoom_changed)
	newSearch = true;

	if ( clearFilters && (typeof resetFilter !== "undefined") ){
		resetFilter("all");
	}

	document.querySelector('.archive').classList.add('--opacity');
	document.querySelector('.map-wrapper').classList.add('--loading');
	document.getElementById('map').classList.add('--opacity');

	let wp_params = '?action=get_store_by_google_search&nonce=' + document.getElementById('offline-search').dataset.nonce;
	let data      = 'address=&lat=' + mapCenter.lat + '&lng=' + mapCenter.lng + '&viewport=' + JSON.stringify(viewport) + '&country=' + queryParams.country;

	return fetch(mswpt_vars.ajax_url + wp_params + '&' + data, {
		method: 'POST',
		headers:{
			'Content-Type': 'application/json',
		}
	}).then(res => res.json())
	.then(response => {
		console.log(response);
		document.querySelector('.no-results-message').classList.add('hidden');

		let noResultsMessage = document.querySelector('.no-results-message');

		if (response.success) {
			if (noResultsMessage != null) {
				noResultsMessage.classList.add('hidden');
			}
			
			document.querySelector('.archive').replaceChildren();
			document.querySelector('.archive').innerHTML = response.data.items;

			document.querySelector('.filters-options').innerHTML = response.data.filters_options;
			
			bindFiltersControls();

			stores = JSON.parse(response.data.json);

			refreshMarkers(stores);
			refreshFilters();
		}
		else {
			if (noResultsMessage != null) {
				noResultsMessage.classList.remove('hidden');
			}

			document.querySelector('.archive').replaceChildren();

			stores.splice(0, stores.length);
			refreshMarkers(null);
			refreshFilters();
		}

		document.querySelector('.archive').classList.remove('--opacity');
		document.getElementById('map').classList.remove('--opacity');
		document.querySelector('.map-wrapper').classList.remove('--loading');

		document.querySelector('.results-count').innerHTML = response.data.count;

		ScrollTrigger.refresh();
	})
	.catch(error => {
		console.error(error);
	});
}

function toggleMap(hideMap) {
	document.getElementById('sticky-wrapper').classList.remove('position-sticky');
	document.getElementById('map').classList.toggle('--active');
	document.querySelector('.archive').classList.toggle('--hidden');
	document.getElementById('sticky-wrapper').scrollIntoView({ behavior: 'smooth' });

	if (hideMap) {
		document.getElementById('sticky-wrapper').classList.add('position-sticky');
	}

	document.getElementById('show-map').classList.toggle('hidden');
	document.getElementById('show-list').classList.toggle('hidden');
}

// function getDirectionsUrl(item) {
//
// 	let name = item.title.toLowerCase().replaceAll(' ', '+');
// 	let address = item.address.toLowerCase().replaceAll(' ', '+');
//
// 	return "https://www.google.it/maps/search/" + encodeURI(name) + "," + encodeURI(address) + "," + encodeURI(item.city) + "," + encodeURI(item.region);
// }

function searchOnline() {
	resetFilter("all");
	document.querySelector('.archive').classList.add('--opacity');

	let term_id   = document.querySelector('.dropdown__options ul li.--selected a').dataset.termid;
	let wp_params = '?action=get_ecommerce_by_tax_term&nonce=' + document.getElementById('online-search').dataset.nonce;
	let data      = 'term_id=' + term_id;

	fetch(mswpt_vars.ajax_url + wp_params + '&' + data, {
		method: 'POST',
		headers:{
			'Content-Type': 'application/json',
		}
	}).then(res => res.json())
	.then(response => {
		console.log(response);
		document.querySelector('.no-results-message').classList.add('hidden');

		let noResultsMessage = document.querySelector('.no-results-message');

		if (response.success) {
			if (noResultsMessage != null) {
				noResultsMessage.classList.add('hidden');
			}

			document.querySelector('.archive').replaceChildren();
			document.querySelector('.archive').innerHTML = response.data.items;

			document.querySelector('.filters-options').innerHTML = response.data.filters_options;

			bindFiltersControls();
			refreshFilters();
		} else {
			if (noResultsMessage != null) {
				noResultsMessage.classList.remove('hidden');
			}

			document.querySelector('.archive').replaceChildren();
			refreshFilters();
		}

		document.querySelector('.archive').classList.remove('--opacity');

		document.querySelector('.results-count').innerHTML = response.data.count;

		ScrollTrigger.refresh();
	})
	.catch(error => {
		console.error(error)
	});
}

function checkOnlineStore(evt) {
	let ctx = evt.target.closest('[name="check-online-form"]');

	if (ctx != null) {
		ctx.querySelector('.button').setAttribute('disabled', true);

		let value     = ctx.querySelector('input').value;
		let wp_params = '?action=check_ecommerce&nonce=' + document.getElementById('check-online-store').dataset.nonce;
		let data      = 'website=' + value;

		fetch(mswpt_vars.ajax_url + wp_params + '&' + data, {
			method: 'POST',
			headers:{
				'Content-Type': 'application/json',
			}
		}).then(res => res.json())
		.then(response => {
			console.log(response);
			ctx.querySelector('.check-result').innerText = response.message;

			const box = document.querySelector('.check-online-box');

			if (response.success) {
				box.classList.remove('check-failed');
				box.classList.add('check-success');
			}
			else {
				box.classList.remove('check-success');
				box.classList.add('check-failed');
			}
		})
		.catch(error => {
			console.error(error)
		});

		ctx.querySelector('.button').removeAttribute('disabled');
	}
}

function checkEmptyInput(event) {
	let field            = event.target.closest('input');
	let offlineSearchBtn = document.getElementById('offline-search');

	if (field.value == "") {
		if (offlineSearchBtn != null)
			offlineSearchBtn.setAttribute('disabled', true);
	}
}

document.addEventListener('DOMContentLoaded', function (evt) {
	let autocompleteInput       = document.getElementById('place-input');
	let geolcateBtn             = document.getElementById('geolocate');
	let offlineSearchBtn        = document.getElementById('offline-search');
	let onlineSearchBtn         = document.getElementById('online-search');
	let mapBtn                  = document.getElementById('show-map');
	let lstBtn                  = document.getElementById('show-list');
	let countrySelectorDropdown = document.querySelector('.country-selector');
	let areaSelectorDropdown    = document.querySelector('.area-selector');
	let checkOnlineBtn          = document.getElementById('check-online-store');

	if (autocompleteInput != null) {
		initSearchbox();

		autocompleteInput.addEventListener('focusin', (ev) => {
			ev.target.closest('input').value = "";
		});

		autocompleteInput.addEventListener('focusout', checkEmptyInput);
		autocompleteInput.addEventListener('input', checkEmptyInput);
	}
	
	if (geolcateBtn != null) {
		geolcateBtn.addEventListener('click', geolocateMe);
	}

	if (offlineSearchBtn != null) {
		offlineSearchBtn.addEventListener('click', (e) => { searchOffline(true); });
	}

	if (onlineSearchBtn != null) {
		onlineSearchBtn.addEventListener('click', searchOnline);
		refreshFilters();
	}

	if (mapBtn != null) {
		mapBtn.addEventListener('click', (e) => { toggleMap(false); });
	}

	if (lstBtn != null) {
		lstBtn.addEventListener('click', (e) => { toggleMap(true); });
	}

	if (countrySelectorDropdown != null) {
		countrySelectorDropdown.addEventListener('click', function(e) {
			if (e.target.closest('.country-selector .dropdown__options li a')) {
				e.preventDefault();

				document.querySelector('.country-selector .selected-value span').innerText = e.target.closest('a').innerText;

				updateOnlineSearchParams(e.target.closest('a').dataset.termid, 'country', true);
			}
		});
	}

	if (areaSelectorDropdown != null) {
		areaSelectorDropdown.addEventListener('click', function(e) {
			if (e.target.closest('.area-selector .dropdown__options li a')) {
				e.preventDefault();

				document.querySelector('.area-selector .selected-value span').innerText = e.target.closest('a').innerText;

				updateOnlineSearchParams(e.target.closest('a').dataset.termid, 'area', true);
			}
		});
	}

	if (checkOnlineBtn != null) {
		checkOnlineBtn.addEventListener('click', checkOnlineStore);

		document.querySelector('[name="check-online-form"] input.form-control').addEventListener('focusin', (evt) => {
			//evt.target.value = "";
			let ctx = evt.target.closest('.check-online-box');

			if (ctx != null) {
				ctx.classList.remove('check-failed','check-success');
				ctx.querySelector('.check-result').innerHTML = "";
			}
		});
	}
});
